import Button from "components/common/Button";
import Colors from "assets/Colors";
import Input from "components/common/Input";
import * as Yup from "yup";
import { useFormik } from "formik";
import CloseIconSmall from "components/icons/CloseIconSmall";
import { useTranslation } from "react-i18next";
import s from "./styles";
import DeleteOutlined from "components/icons/DeleteOutlined";


function AddTableModal({
  close,
  typeTable,
  handleAddTable,
  handleEditTable,
  editingTable,
  handleDeleteTable,
  currentRoom,
}) {

  const { t } = useTranslation();

  const {
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    dirty,
    isValid,
    resetForm,
  } = useFormik({
    initialValues: {
      name: editingTable?.name || "",
      quantity: editingTable?.capacity || null,
      location: "",
      type: editingTable?.type || typeTable,
    },

    enableReinitialize: true,

    onSubmit: (values) => {

      values.quantity = values.quantity || 0;

       if (editingTable) {
            handleEditTable(
              values.type,
              values.name,
              values.quantity,
              currentRoom._id,
              editingTable._id
            );
          } else {
            handleAddTable(values.type, values.name, values.quantity, currentRoom.tables, currentRoom.decorations);
          }

          resetForm();
          close();
    },

    validationSchema: Yup.object().shape({
      name: Yup.string().required(t("formValidations.required")),
    }),
  });

  return (
    <s.Container>
      <s.HeaderContainer>
        <s.CloseButtonWrapper
          onClick={() => {
            // resetForm();
            close();
          }}
        >
          <CloseIconSmall />
        </s.CloseButtonWrapper>
        <div>
            {
              editingTable ? t('components.Rooms.AddTableModal.editTable')  : t('components.Rooms.AddTableModal.addTable')
            }
          </div>

        {editingTable ? (
          <Button
            type="text"
            style={{
              width: "40px",
              height: "40px",
              border: 'none',
              background: 'transparent',
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => handleDeleteTable(editingTable)}
            icon={
              <DeleteOutlined size="18px"
                color={Colors.tertiary}
              />
            }
          >
          </Button>
        ) : (
          <>&nbsp;</>
        )}
      </s.HeaderContainer>
      <s.BodyWrapper>
        <s.SubTitle>{t('components.Rooms.AddTableModal.tableName')}*</s.SubTitle>
        <Input
          style={{
            marginBottom: "25px",
          }}
          placeholder={t("SubCategory.fields.subcategory.placeholder")}
          name="name"
          {...getFieldProps("name")}
        // onChange={handleChange}
        // value={values.name}
        />
        <s.SubTitle>{t('components.Rooms.AddTableModal.numberOfDinners')}</s.SubTitle>
        <Input
          style={{
            marginBottom: "25px",
          }}
          min="0"
          placeholder="2"
          name="quantity"
          type="number"
          {...getFieldProps("quantity")}
        />

        {editingTable && (
          <>
            <s.SubTitle>{t('components.Rooms.AddTableModal.shape')}</s.SubTitle>

            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                marginBottom: "25px",
              }}
            >
              <s.containerShapeSelect
                style={{
                  border: values.type === "circle" ? "1px solid #000" : "none",
                }}
              >
                <s.CircularButton
                  onClick={() => setFieldValue("type", "circle")}
                />
              </s.containerShapeSelect>
              <s.containerShapeSelect
                style={{
                  border: values.type === "square" ? "1px solid #000" : "none",
                }}
              >
                <s.SquareButton
                  onClick={() => setFieldValue("type", "square")}
                />
              </s.containerShapeSelect>
              <s.containerShapeSelect
                style={{
                  border:
                    values.type === "rectangular" ? "1px solid #000" : "none",
                }}
              >
                <s.RectangularButton
                  onClick={() => setFieldValue("type", "rectangular")}
                />
              </s.containerShapeSelect>
            </div>
          </>
        )}
      </s.BodyWrapper>
      <s.containerButtons>
        <Button
          // disabled={editing || loading}
          type="primary"
          style={{
            background: "transparent",
            color: Colors.text_primary,
            borderColor: Colors.text_primary,
            width: "200px",
            fontWeight: "500",
            height: "40px",
          }}
         onClick={() => {
          close();
          resetForm();
         }}
        >
          {t('components.Rooms.AddTableModal.cancel')}
        </Button>
        <Button
          disabled={!isValid || !dirty}
          type="primary"
          style={{
            background: Colors.primary,
            color: Colors.text_on_secondary,
            borderColor: Colors.text_primary,
            width: "200px",
            fontWeight: "500",
            height: "40px",
          }}
          onClick={() => handleSubmit()}
        >
          {
             t('components.Rooms.AddTableModal.saveTable')
          }
        </Button>
      </s.containerButtons>
    </s.Container>
  );
}

export default AddTableModal;
